
class MatterPortHelp extends HTMLElement {

    /**
     * Create a new matterport-help Element
     */
    constructor() {
        super();

        this.isOpen = parseInt(window.sessionStorage.getItem('hide-help') || '0') === 0;
        this.dataset.open = this.isOpen ? 'true' : 'false';

        window.addEventListener('keyup', (event) => {
            if (event.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });

        let closeButton = this.querySelector('[data-close]');
        if (closeButton) {
            closeButton.addEventListener('click', (event) => {
                event.preventDefault();
                if (this.isOpen) {
                    this.close();
                }
            });
        }

        let overlays = Array.from(this.querySelectorAll('[data-target][data-placement]'));
        if (overlays) {
            if (typeof window.app !== 'undefined' && window.app.ready === true) {
                this.positionOverlays(overlays);
            } else {
                document.addEventListener('app:ready', this.positionOverlays.bind(this, overlays));
            }
        }

        let overlayCloseButton = document.createElement('BUTTON');
        overlayCloseButton.type = 'button';
        overlayCloseButton.classList.add('close-button');
        overlayCloseButton.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
        `;
        overlayCloseButton.addEventListener('click', this.close.bind(this));
        this.appendChild(overlayCloseButton);
    }

    /**
     * Position Overlays
     */
    async positionOverlays(overlays) {
        const floating = window.app.vendors.floating;

        overlays.map(source => {
            const target = document.querySelector(source.dataset.target);
            floating.autoUpdate(target, source, () => {
                floating.computePosition(
                    target,
                    source,
                    {
                        placement: source.dataset.placement || 'top-end',
                        middleware: [
                            floating.offset({
                                alignmentAxis: 20
                            })
                        ]
                    } 
                ).then(({x, y}) => {
                    source.style.top = `${y}px`;
                    source.style.left = `${x}px`;
                    source.style.position = 'fixed';
                    source.hidden = false;
                });
            });
        });
    }

    /**
     * Toggle Help Meu
     */
    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Open Help Menu
     */
    open() {
        this.isOpen = true;
        this.dataset.open = 'true';
    }

    /**
     * Close Help Menu
     */
    close() {
        this.isOpen = false;
        this.dataset.open = 'false';
        window.sessionStorage.setItem('hide-help', '1');
    }

}

window.customElements.define('matterport-help', MatterPortHelp);
